import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  onError: (error: Error, errorInfo: ErrorInfo) => void;
}

/** Very simple component to catch any uncaught errors from inside a component's children */
export class CallbackErrorBoundary extends Component<Props> {
  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.props.onError(error, errorInfo);
  }

  public render(): ReactNode {
    return this.props.children;
  }
}
